<div class="toggle-instruction-content">
  <ion-grid>
    <ion-row>
      <ion-col>
        <h3>
          {{ message }}
        </h3>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="center-item">
        <ion-button fill="outline" color="primary" disabled>YES</ion-button>
      </ion-col>
      <ion-col class="center-item">OR</ion-col>
      <ion-col class="center-item">
        <ion-button fill="outline" color="primary" disabled>NO</ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-button (click)="close()" color="primary"> I UNDERSTAND </ion-button>
</div>